export default "__VITE_ASSET__BO3UxcIY__"